import React from 'react';
import { Link } from 'react-router-dom';
import './style.css';
import serviceImg1 from '../../images/about/mission-vision.png';
import serviceImg2 from '../../images/about/values.png';

const ServiceForAbout = () => {
    return (
        <div className="service-area">
            <div className="container">
                <div className="service-wrap">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-12">
                            <div className="service-item">
                                <div className="service-title">
                                    <div className="wpo-section-title">
                                        <span>Our Mission</span>
                                    </div>
                                    <h2>Making Quality Quran Education Accessible</h2>
                                    <p>Our mission is to make quality Quran education accessible to every UK Muslim family – vital for the nearly four million Muslims in the UK. We aim to empower each learner with authentic Quranic knowledge and confidence in recitation.</p>
                                </div>
                                <div className="service-title mt-4">
                                    <div className="wpo-section-title">
                                        <span>Our Vision</span>
                                    </div>
                                    <h2>Connecting with the Quran's Message</h2>
                                    <p>We envision a community where every child and adult can connect with the Quran's message. By combining traditional teaching with modern online tools, we help students develop a lifelong love for Quranic learning.</p>
                                </div>
                                <div className="btns">
                                    <Link to="/home#booking-form" className="theme-btn-s3">Book Free Trial</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                            <div className="service-img">
                                <img src={serviceImg1} alt="Quran Education" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="service-wrap-s2">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-12">
                            <div className="service-img">
                                <img src={serviceImg2} alt="Our Teaching Methodology" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                            <div className="service-item">
                                <div className="service-title">
                                    <div className="wpo-section-title">
                                        <span>Our Values</span>
                                    </div>
                                    <h2>Core Principles That Guide Our Teaching</h2>
                                    <div className="values-list">
                                        <div className="value-item">
                                            <h3><i className="ti-book"></i> Knowledge & Faith</h3>
                                            <p>Empowering students with understanding of the Quran and its teachings.</p>
                                        </div>
                                        <div className="value-item">
                                            <h3><i className="ti-hand-open"></i> Compassion</h3>
                                            <p>Teaching with patience, care and respect for each learner's needs.</p>
                                        </div>
                                        <div className="value-item">
                                            <h3><i className="ti-check"></i> Authenticity</h3>
                                            <p>Following traditional Tajweed rules and authentic sources in every lesson.</p>
                                        </div>
                                        <div className="value-item">
                                            <h3><i className="ti-world"></i> Community</h3>
                                            <p>Supporting UK Muslim families and adapting lessons to our local context.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="about-row-wrapper">
                    <div className="row">
                        <div className="col-lg-6 col-md-12">
                            <div className="who-we-are-section">
                                <div className="section-title">
                                    <div className="service-icon">
                                        <i className="ti-user"></i>
                                    </div>
                                    <span>About Our Team</span>
                                    <h2>Who We Are</h2>
                                </div>
                                <div className="who-we-are-text">
                                    <p>Our team consists of qualified Quran teachers from the UK and around the world. We have both male and female tutors, all certified in Tajweed and Quranic studies. Each tutor is a Experienced Arabic speaker or highly proficient in Arabic, experienced in teaching children and adults through online classes.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                            <div className="teaching-methodology-section">
                                <div className="section-title">
                                    <div className="service-icon">
                                        <i className="ti-pencil"></i>
                                    </div>
                                    <span>How We Teach</span>
                                    <h2>Our Teaching Methodology</h2>
                                </div>
                                <div className="teaching-methodology-text">
                                    <p>We use a structured, step-by-step curriculum that builds from basics to advanced levels. Classes are live and interactive, using digital whiteboards, flashcards and worksheets to reinforce learning. Students receive regular feedback and progress checks.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ServiceForAbout; 